import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { fetchAdminError, fetchAdminStart, setAdminData } from '../reducers/adminReducer';
import { AdminService } from '../services/admin';

export const useFetchAdmin = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state: RootState) => state.admin);

  const fetchAdmin = async () => {
    if (loading) return;

    dispatch(fetchAdminStart());
    const { data, error } = await AdminService.getAdmin();
    if (data) {
      dispatch(setAdminData(data));
    } else if (error) {
      dispatch(fetchAdminError(error.message));
    }
    return undefined;
  };

  return fetchAdmin;
};
